import { errorDispatcher, getOptionsQuery } from "../helpers";
import { appSetLoading } from "../store/actions/appAction";
import axios from "../axios/axios";
import { setTableData } from "../store/actions/dataTableAction";
import { store } from "store/store";
export const apiGetProperty = ({ cb,id }) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    let url = `/productproperty`
    if (id) {
        url += `/${id}`
    }


    axios
        .get(url, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            console.log(response)
            cb(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            dispatch(appSetLoading(false));
            errorDispatcher(error, dispatch);
        });


}
export const apiDeleteProperty = ({ id, cb }) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    const url = `/productproperty`

    axios
        .delete(url, {
            headers: { Authorization: `Bearer ${Token}` },
            data: { ids:[id], },
        })
        .then((response) => {
            dispatch(appSetLoading(false));
            cb(response.data)
            dispatch(apiSetAlert("ویژگی با موفقیت حذف گردید", "success"));
            
        })
        .catch((error) => {
            dispatch(appSetLoading(false));
            errorDispatcher(error, dispatch);
        });


}
export const apiAddProperty = ({ data, cb }) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    const url = `/productproperty`
    axios
        .post(url, { ...data }, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            console.log(response)
            cb(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            dispatch(appSetLoading(false));
            errorDispatcher(error, dispatch);
        });

}
export const apiEditProperty = ({ data, cb,id }) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    const url = `/productproperty/${id}`
    axios
        .put(url, { ...data }, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            console.log(response)
            cb(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            dispatch(appSetLoading(false));
            errorDispatcher(error, dispatch);
        });

}
